import React from 'react';
import NavBar from '../Shared/NavBar/NavBar';

const DashBoard = () => {
    return (
        <div>
            <NavBar></NavBar>
            <h3 className="p-5 text-center">coming soon</h3>
        </div>
    );
};
export default DashBoard;